module.exports = __webpack_public_path__ + "static/media/DSCN03401.e24a0341.jpg";